<!-- Linha de lançamento: Item | Qtd. | Preço unit. | Subtotal | +
     Modelo do AvatiERP — escolher um item NÃO o manda ao carrinho; ele fica
     aqui até o operador confirmar (Enter na quantidade ou clique no +).

     ⚠️ Preço unit. e Subtotal são CAIXAS DE LEITURA, não inputs. É o que
     preserva a regra do fdf285f9 (o funcionário não altera o preço de venda)
     enquanto se copia o layout do ERP. -->
<div class="venda-linha-lancamento">
  <div class="vll-campo vll-campo--item">
    <label for="venda-item-busca">{{ 'contador_operar.venda.item_rotulo' | translate }}</label>
    <!-- [devolverFocoAposEscolher]="false": quem manda no foco é este
         componente — depois de escolher, o cursor vai para a quantidade.
         (itemEscolhidoViaCodigo) é o desvio do LEITOR DE CÓDIGO DE BARRAS,
         que segue indo direto ao carrinho. -->
    <app-operar-venda-item-busca
      inputId="venda-item-busca"
      [cfgMoeda]="cfgMoeda"
      [disabled]="disabled"
      [permitirCriarItem]="true"
      [devolverFocoAposEscolher]="false"
      (itemEscolhido)="onItemEscolhido($event)"
      (itemEscolhidoViaCodigo)="onItemBipado($event)"
      (selecaoLimpa)="onSelecaoLimpa()"
      (abrirLista)="abrirLista.emit()"
      (criarItem)="criarItem.emit()">
    </app-operar-venda-item-busca>
  </div>

  <div class="vll-campo vll-campo--qtd">
    <label for="venda-linha-qtd">{{ 'contador_operar.venda.col_qtd' | translate }}</label>
    <!-- (keydown.enter) no elemento: o evento borbulha do <input> interno do
         p-inputNumber. O Enter é o caminho de teclado para lançar. -->
    <p-inputNumber
      #qtdRef
      inputId="venda-linha-qtd"
      [(ngModel)]="qtd"
      [min]="1"
      [locale]="cfgMoeda.locale"
      [showButtons]="true"
      buttonLayout="horizontal"
      decrementButtonClass="p-button-secondary"
      incrementButtonClass="p-button-secondary"
      incrementButtonIcon="pi pi-plus"
      decrementButtonIcon="pi pi-minus"
      [disabled]="!item || disabled"
      inputStyleClass="input-qtd"
      styleClass="venda-stepper"
      (keydown.enter)="confirmar()">
    </p-inputNumber>
  </div>

  <div class="vll-campo vll-campo--preco">
    <label id="vll-rotulo-preco">{{ 'contador_operar.venda.col_preco' | translate }}</label>
    <div class="vll-box" [class.vll-box--vazio]="!item" aria-labelledby="vll-rotulo-preco" role="status">
      {{ precoUnitario | moedaSimbolo: cfgMoeda.symbol : cfgMoeda.digits : cfgMoeda.locale }}
    </div>
  </div>

  <div class="vll-campo vll-campo--subtotal">
    <label id="vll-rotulo-subtotal">{{ 'contador_operar.venda.col_subtotal' | translate }}</label>
    <div class="vll-box vll-box--forte" [class.vll-box--vazio]="!item" aria-labelledby="vll-rotulo-subtotal" role="status">
      {{ subtotal | moedaSimbolo: cfgMoeda.symbol : cfgMoeda.digits : cfgMoeda.locale }}
    </div>
  </div>

  <div class="vll-campo vll-campo--acao">
    <!-- Rótulo invisível só para manter as cinco caixas alinhadas pelo topo; o
         botão tem nome acessível próprio via aria-label. -->
    <label aria-hidden="true">&nbsp;</label>
    <!-- Durante uma EDIÇÃO o mesmo botão vira "confirmar": o ícone e o rótulo
         mudam para avisar que o clique devolve a linha à lista, em vez de
         acrescentar mais uma. A AÇÃO é a mesma (`confirmar`) — só o rótulo. -->
    <button pButton
      type="button"
      [icon]="editando ? 'pi pi-check' : 'pi pi-plus'"
      class="vll-botao-add"
      [disabled]="!item || disabled"
      [attr.aria-label]="(editando
          ? 'contador_operar.venda.linha.atualizar_aria'
          : 'contador_operar.venda.linha.adicionar_aria') | translate"
      [pTooltip]="(editando
          ? 'contador_operar.venda.linha.atualizar_tooltip'
          : 'contador_operar.venda.linha.adicionar_tooltip') | translate"
      tooltipPosition="top"
      tooltipStyleClass="vll-tooltip"
      (click)="confirmar()">
    </button>
  </div>
</div>
